import React from 'react';
import { List, ListItemButton, ListItemText, Collapse } from '@mui/material';
import { ChevronRight, ExpandMore } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';

const authorMenuItems = [
    { text: "My Documents", to: '/author' },
    { text: "New Document", to: '/author/new' },
];

function AuthorMenu({ isAuthorMenuOpen, onAuthorMenuClick, toggleMenu }) {
    return (
        <React.Fragment>
            <ListItemButton onClick={onAuthorMenuClick}>
                <ListItemText primary="Author" />
                {isAuthorMenuOpen ? <ExpandMore /> : <ChevronRight />}
            </ListItemButton>
            <Collapse in={isAuthorMenuOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    {authorMenuItems.map((item) => (
                        <ListItemButton key={item.text} component={RouterLink} to={item.to} sx={{ pl: 4 }} onClick={toggleMenu}>
                            <ListItemText primary={item.text} />
                        </ListItemButton>
                    ))}
                </List>
            </Collapse>
        </React.Fragment>
    );
}

export default AuthorMenu;
